<div class="container">
  <h3 id="myBuyers" (click)="toggleBuyers()">{{ areBuyers ? 'My Buyers' : 'My Suppliers'}}</h3>


      <mat-form-field id="search">
        <input matInput placeholder="Search" autocomplete="off">
      </mat-form-field>

    

  <ul class="blist">
      <li *ngFor="let buyer of buyers">
        <a (click)="openModal(buyer)">{{buyer.name}}</a>
      </li>
  </ul>
<!-- <div id="table">
    <mat-table [dataSource]="dataSource" matSort class="blist">
      <ng-container matColumnDef="name">
        <th *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell *matCellDef="let element"> {{element.name}} </td>
      </ng-container>
      <ng-container matColumnDef="amount">
        <th *matHeaderCellDef mat-sort-header> Amount </th>
        <td mat-cell *matCellDef="let element"> {{element.amount | currency}} </td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th *matHeaderCellDef mat-sort-header> Delivery Date </th>
        <td mat-cell *matCellDef="let element"> {{element.date | date}} </td>
      </ng-container>
      <ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"><a (click)="openModal(buyer)"></a></tr>
      </ng-container>
    </mat-table>
  </div> -->
  

</div>














<!-- 
<div class="container">
    <h3>My Buyers</h3>
    <div>FILTER AND SORT HERE</div>
    <ul class="blist" *ngFor="let buyer of buyers">
      <li>
        <a (click)="onClick()">{{buyer.name}}</a>
      </li>
    </ul>
  </div> -->